import { Autor } from '../../../../interfaces/Publication';

interface Props {
    author: Autor
}

export const AuthorCard = ({ author }: Props) => {
  return (
    <div className="card-author">
        <div className="card-author__name">{author.fullName}</div>
        <div className="card-author__email">
            <span>{ author.email }</span>
        </div>
        <div className="card-author__profession">{author.profesion}</div>
        <div className="card-author__affiliation">{author.afiliacion}</div>
    </div>
  )
}